export default "__VITE_ASSET__DfzJsfy2__"